<block-ui name="main">
  <mat-sidenav-container>
    <router-outlet></router-outlet>
  </mat-sidenav-container>
</block-ui>